export const textAreaResize = (e) => {
  const textarea = e.currentTarget;

  if (textarea) {
    const elementHeight = e.currentTarget.getBoundingClientRect().height
    textarea.style.height = "auto";

    // Adjust height based on scrollHeight
    textarea.style.height = `${textarea.scrollHeight}px`;
    if (textarea.scrollHeight > (elementHeight + 50)) {
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }
};



export const compareStrings = (stringOne, stringTwo) => {
  const idCompare = stringOne.localeCompare(stringTwo)

  if (idCompare === -1) {
    return `${stringOne}${stringTwo}`

  } else {
    return `${stringTwo}${stringOne}`
  }
}


export const copyText = (textToCopy) => {
  navigator.clipboard.writeText(textToCopy)
  .then(() => {
    alert('Text copied to clipboard!');
  })
  .catch(err => {
    alert(`Oops...couldn't copy to clipboard!`);
  });
}


export const setAuthInStorage = (id) => {
  localStorage.setItem('wowi-auth-token', JSON.stringify(id));
}


    
